<template>
  <div class="content">
    <div class="logo">
      <svg
        id="Ebene_1"
        data-name="Ebene 1"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 375.4 95.9"
      >
        <text class="cls-1" transform="translate(5.4 141.7)">
          <tspan x="0" y="0">PHILOSOPHIE &amp; ETHIK</tspan>
        </text>
        <text class="cls-2" transform="translate(5.4 141.7)">
          <tspan x="0" y="0">AUDIO</tspan>
        </text>
        <text class="cls-1" transform="translate(5.4 141.7)">
          <tspan x="0" y="0">KINDERBÜCHER</tspan>
        </text>
        <text class="cls-1" transform="translate(5.4 141.7)">
          <tspan x="0" y="0">GESCHENKE</tspan>
        </text>
        <text class="cls-3" transform="translate(5.4 141.7)">
          <tspan class="cls-5" x="0" y="0">KINDERGARTEN &amp; PÄDAGOGIK</tspan>
          <tspan class="cls-8" x="602.1" y="0"></tspan>
        </text>
        <text class="cls-3" transform="translate(5.4 141.7)">
          <tspan class="cls-6" x="0" y="0">LEBEN</tspan>
          <tspan class="cls-7" x="137.8" y="0">&amp; GESELLSCHAFT</tspan>
        </text>
        <g>
          <path
            class="cls-4"
            d="M54.3,80.4c0,1.8-.4,2.1-2.1,2.1h-9.1c-1.7,0-2.1-.3-2.1-2.1v-27.5h-18.7v27.5c0,1.8-.4,2.1-2.1,2.1h-9.1c-1.7,0-2.1-.3-2.1-2.1V17.1c0-1.8.4-2.1,2.1-2.1h9.1c1.7,0,2.1.3,2.1,2.1v25.2h18.7v-25.2c0-1.8.4-2.1,2.1-2.1h9.1c1.7,0,2.1.3,2.1,2.1v63.2Z"
          />
          <path
            class="cls-4"
            d="M114.6,80.4c0,1.8-.3,2.1-2,2.1h-32.3c-1.7,0-2.1-.3-2.1-2.1V17.1c0-1.8.4-2.1,2.1-2.1h32.3c2,0,2.5.2,2.5,1.1s0,.7-.3,1.4l-1.9,6.6c-.4,1.5-1.5,1.6-2.3,1.6h-19.1v16.2h16.7c1.8,0,2.1.3,2.1,2.1v6.5c0,1.7-.4,2-2.1,2h-16.7v19.3h21c1.8,0,2.1.3,2.1,2.1v6.5Z"
          />
          <path
            class="cls-4"
            d="M147.3,80.4c0,1.8-.4,2.1-2.1,2.1h-9.1c-1.7,0-2.1-.3-2.1-2.1V17.1c0-1.8.4-2.1,2.1-2.1h15.9c7.6,0,22.9.5,22.9,19s-7.6,16.3-11.2,18.2l14.7,26.3c.3.5.8,1.3.8,1.9s-1,.9-2,1.2l-8.3,2.4c-.4,0-1,.2-1.4.2s-1.3-1.2-2.3-3l-13.3-26.5h-4.7v25.8ZM149.8,44.3c6.4,0,11.8-1,11.8-10s-5.6-8.9-10.7-8.9h-3.6v18.9h2.6Z"
          />
          <path
            class="cls-4"
            d="M214.8,15.1c18.8,0,28.6,6.1,28.6,33.3s-11.4,34-28.9,34h-15c-1.7,0-2.1-.4-2.1-2.1V17.1c0-1.8.4-2.1,2.2-2.1h15.2ZM214.2,71.8c11.1,0,15.2-4.8,15.2-23.6s-4.2-22.5-15.2-22.5h-3.5v46.1h3.5Z"
          />
          <path
            class="cls-4"
            d="M299.4,80.4c0,1.8-.3,2.1-2,2.1h-32.3c-1.7,0-2.1-.3-2.1-2.1V17.1c0-1.8.4-2.1,2.1-2.1h32.3c2,0,2.5.2,2.5,1.1s0,.7-.3,1.4l-1.9,6.6c-.4,1.5-1.5,1.6-2.3,1.6h-19.1v16.2h16.7c1.8,0,2.1.3,2.1,2.1v6.5c0,1.7-.4,2-2.1,2h-16.7v19.3h21c1.8,0,2.1.3,2.1,2.1v6.5Z"
          />
          <path
            class="cls-4"
            d="M332,80.4c0,1.8-.4,2.1-2.1,2.1h-9.2c-1.7,0-2.1-.3-2.1-2.1V17.1c0-1.8.4-2.1,2.1-2.1h15.9c7.6,0,22.9.5,22.9,19s-7.6,16.3-11.2,18.2l14.6,26.3c.3.5.8,1.3.8,1.9s-1,.9-2,1.2l-8.3,2.4c-.4,0-1,.2-1.4.2s-1.3-1.2-2.3-3l-13.3-26.5h-4.7v25.8ZM334.6,44.3c6.4,0,11.8-1,11.8-10s-5.6-8.9-10.7-8.9h-3.6v18.9h2.6Z"
          />
        </g>
      </svg>
    </div>

    <h1>Unzulässiger Zugriff!</h1>

    <p>Liebe Besucherinnen und Besucher,</p>
    <p>Der Zugriff auf Herder.de ist für Sie derzeit nicht möglich.</p>
    <p>Wir danken Ihnen für Ihr Verständnis.</p>
    <p>
      Viele Grüße,<br />
      Ihr Herder.de-Team
    </p>
  </div>
</template>

<script>
export default {
  name: 'Modul',
  props: {
    context: {
      type: Object,
    },
  },
};
</script>

<style>
body {
  font-family: helvetica, sans-serif;
  font-size: 117%;
  line-height: 1.6;
}

h1 {
  margin-bottom: 2rem;
  line-height: 1.4;
  text-align: center;
  font-size: 1.8rem;

  @media only screen and (min-width: 600px) {
    text-align: center;
    font-size: 3rem;
  }
}

.logo {
  max-width: 220px;
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 40px;
  margin-top: 40px;
  margin-left: auto;
  margin-right: auto;

  @media only screen and (min-width: 600px) {
    margin-top: 70px;
    margin-bottom: 100px;
    margin-left: 0;
    margin-right: 0;
    max-width: 300px;
  }
}

.content {
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;
  padding: 20px;

  @media only screen and (min-width: 600px) {
    padding: 30px;
  }

  text-align: left;
}

.cls-1,
.cls-2,
.cls-3 {
  display: none;
  font-family: OpenSans-Semibold, 'Open Sans';
  font-size: 40.3px;
  font-weight: 600;
}

.cls-1,
.cls-2,
.cls-3,
.cls-4 {
  fill: #c1082c;
}

.cls-1,
.cls-5 {
  letter-spacing: 0em;
}

.cls-2,
.cls-6 {
  letter-spacing: 0em;
}

.cls-4 {
  stroke-width: 0px;
}

.cls-7 {
  letter-spacing: 0em;
}

.cls-8 {
  letter-spacing: 0em;
}
</style>
